/*

👋 “Hey” from the Praxis team!

'apiConfig' is one pattern that can be used to set environment-based values at build time.
This happens by creating an environment variable REACT_APP_ENV, and then matching corresponding
keys to each environment in the 'envConfigs' object below. To learn more about how to set
REACT_APP_ENV, view the README generated with this app.


For an alternative pattern - using TAP configuration to set environment-based values at cluster initialization - see:
@praxis/component-runtime-env - https://praxis.prod.target.com/components/runtime-env

*/

import merge from 'lodash/merge'

// configurations shared between most or all environments can be stored in commonConfig
const commonConfig = {
  auth: {
    authorizationUrl:
      'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
    logoutUrl:
      'https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html',
  },
  polBackend: 'https://stgapi-internal.target.com/bpd_pol/v1',
  polApiKey: '7b7c403c9b5134d57179aad8336d7b0b6f65537a',
}

const envConfigs = {
  // dev is the default development environment set by .env.development and the default pipeline in .vela.yml
  dev: {
    auth: {
      // create a non-prod ID2.0 OAuth Client ID unique to your app needs at http://go/oauth
      // this clientID will not work in deployed environments
      clientId: 'bpd_pol_npe_im',
    },
    polBackend: 'https://stage-api.target.com/bpd_pol/v1',
    polApiKey: '7b7c403c9b5134d57179aad8336d7b0b6f65537a',
  },
  /*
  // additional environments can be added:
  stg: {

  },
  */
  prod: {
    auth: {
      // keys in envConfigs will overwrite keys from commonConfig
      authorizationUrl:
        'https://oauth.iam.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl:
        'https://oauth.iam.partnersonline.com/login/responses/logoff.html',
      // clone your non-prod ID2.0 OAuth Client ID to a production Client ID at http://go/oauth',
      // this clientID will not work in deployed environments
      clientId: 'bpd_pol_prod_im',
    },
    polBackend: 'https://api.target.com/bpd_pol/v1',
    polApiKey: '319e4e1ccb8545a642c4052f44d0581c93ad6c6f',
  },
}

const appEnv = process.env.REACT_APP_ENV
const config = envConfigs[appEnv]

// commonConfig and the config for the matching REACT_APP_ENV are combined.
// Values in the environment-specific config will overwrite commonConfig keys
// if they share the same name.
const apiConfig = merge(commonConfig, config)

export default apiConfig

// The following code block is purely for demonstration purposes and can be removed.
if (process.env.NODE_ENV !== 'production') {
  console.log(`${appEnv} ENV apiConfig:`, apiConfig)
}
